/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: "copied" | "failed" | "idle" }} Commons_Error_Toast_Copy_LabelInputs */

const de_commons_error_toast_copy_label = /** @type {(inputs: Commons_Error_Toast_Copy_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.status === "idle") return /** @type {LocalizedString} */ (`Fehlercode kopieren`);
	if (i?.status === "copied") return /** @type {LocalizedString} */ (`Kopiert!`);
	if (i?.status === "failed") return /** @type {LocalizedString} */ (`Kopieren fehlgeschlagen`);
	return /** @type {LocalizedString} */ ("commons_error_toast_copy_label");
};

/** @type {(inputs: Commons_Error_Toast_Copy_LabelInputs) => LocalizedString} */
const en_commons_error_toast_copy_label = de_commons_error_toast_copy_label;

/**

* @param {Commons_Error_Toast_Copy_LabelInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_error_toast_copy_label = /** @type {((inputs: Commons_Error_Toast_Copy_LabelInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Error_Toast_Copy_LabelInputs, { locale?: "de" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_error_toast_copy_label(inputs)
	return en_commons_error_toast_copy_label(inputs)
});